import { ADMIN_API_CONFIG } from "@/constants/api-configs"
import { DefaultImage, Media, MediaUpload } from "@/lib/external-components"
import { CaretDownOutlined, CaretUpOutlined, PlusOutlined } from "@ant-design/icons"
import { Button, Image, Modal } from "antd"
import Title from "antd/es/typography/Title"
import React, { useState } from "react"
import { t } from "../../../../languages/i18n"
import { MediaData } from "../../../../lib/config/types"

interface FeaturedImageProps {
  selectedMedia: MediaData[]
  setSelectedMedia: (media: MediaData[]) => void
}

const FeaturedImage: React.FC<FeaturedImageProps> = ({ selectedMedia, setSelectedMedia }) => {
  const [isImageVisible, setImageVisible] = useState(true)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isChooseMedia, setIsChooseMedia] = useState(true)
  const handleOpenModal = () => {
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  const handleSelectMedia = (media: MediaData) => {
    setSelectedMedia([...selectedMedia, media])

    setIsModalOpen(false)
  }

  const handleRemoveImage = (index: number) => {
    const updatedMedia = selectedMedia.filter((_, i) => i !== index)
    setSelectedMedia(updatedMedia)
  }

  return (
    <div className="categories border border-gray-300 rounded-[10px] mb-5">
      <div className="flex justify-between items-center px-4 py-2 border-b">
        <Title level={4} className="!m-0">
          {t("Featured Image")}
        </Title>
        <Button
          onClick={() => setImageVisible(!isImageVisible)}
          className="flex items-center"
          icon={isImageVisible ? <CaretDownOutlined /> : <CaretUpOutlined />}
          type="text"
        ></Button>
      </div>
      {!isImageVisible || (
        <div className="m-4">
          {selectedMedia.length > 0 && (
            <Button
              variant="outlined"
              color="primary"
              icon={<PlusOutlined />}
              onClick={handleOpenModal}
              className="mb-4"
            >
              {t("Add More Images")}
            </Button>
          )}
          {selectedMedia.length === 0 ? (
            <div className="flex flex-col gap-4 p-2">
              <Image
                src={DefaultImage}
                alt="featured"
                className="w-full cursor-pointer"
                preview={false}
                onClick={handleOpenModal}
              />
              <Button variant="outlined" color="primary" icon={<PlusOutlined />} onClick={handleOpenModal}>
                {t("Set Featured Image")}
              </Button>
            </div>
          ) : (
            <div className="flex flex-wrap gap-4">
              {selectedMedia.map((media, index) => {
                const mediaUrl = typeof media === "string" ? media : media.url
                return (
                  <div key={index} className="relative">
                    <Image
                      // onClick={handleOpenModal}
                      src={`${ADMIN_API_CONFIG.API_URL}${mediaUrl}`}
                      alt="featured"
                      className="w-full"
                      width={100}
                      height={100}
                    />
                    <Button color="danger" className="absolute top-1 right-1" onClick={() => handleRemoveImage(index)}>
                      {t("Remove")}
                    </Button>
                  </div>
                )
              })}
            </div>
          )}
        </div>
      )}
      <Modal
        open={isModalOpen}
        title={<span className="ml-4">{t("Select Media")}</span>}
        onCancel={handleCloseModal}
        style={{ top: 20 }}
        width="95%"
        footer={null}
      >
        <div className="ml-4 mt-5">
          <Button
            onClick={() => setIsChooseMedia(true)}
            className="mr-2"
            style={{ backgroundColor: isChooseMedia ? "blue" : "initial", color: isChooseMedia ? "white" : "initial" }}
          >
            {t("Select Media")}
          </Button>
          <Button
            onClick={() => setIsChooseMedia(false)}
            style={{
              backgroundColor: !isChooseMedia ? "blue" : "initial",
              color: !isChooseMedia ? "white" : "initial",
            }}
          >
            {t("Upload Media")}
          </Button>
        </div>
        <div>
          {isChooseMedia ? (
            <Media isOpenModal={true} onSelectMedia={handleSelectMedia} />
          ) : (
            <MediaUpload isOpenModal={true} setChooseMedia={setIsChooseMedia} />
          )}
        </div>
      </Modal>
    </div>
  )
}

export default FeaturedImage
